import type React from 'react'
import type { JSX } from 'react'
import type { IPrimaryButtonProps } from 'atoms/Button/Templates'
import type { ITextBlockDescriptionForBundleGridCenterProps } from 'blocks/TextBlock/Templates'
import type { IContainerDescriptionProps } from '../ContainerDescription'

import { PrimaryButton } from 'atoms/Button/Templates'
import { TextBlockDescriptionForBundleGridCenter } from 'blocks/TextBlock/Templates'
import { FIXED_INDENTS, LAYOUT } from 'vars/index'
import { ContainerDescription } from '../ContainerDescription'
import {
  ContainerDescriptionAlignItems,
  ContainerDescriptionRowGap,
} from '../ContainerDescription.h'

export interface IContainerDescriptionForBundleGridCenteredProps extends Omit<
  IContainerDescriptionProps,
  'children'
> {
  children?: React.ReactNode
  title?: ITextBlockDescriptionForBundleGridCenterProps['title']
  description?: ITextBlockDescriptionForBundleGridCenterProps['description']
  buttonTitle?: IPrimaryButtonProps['title']
  isButtonShown?: boolean
  onSeeAllClick?: () => void
  rentedText?: string
}

export const ContainerDescriptionForBundleGridCentered = ({
  title = '',
  description = '',
  buttonTitle = '',
  isButtonShown = true,
  alignItems = ContainerDescriptionAlignItems.Center,
  rowGap = ContainerDescriptionRowGap.INDENT_60,
  children,
  paddings = [LAYOUT.VerticalGridTitleCategoryPaddings, FIXED_INDENTS.INDENT_0],
  onSeeAllClick,
  rentedText,
  ...rest
}: IContainerDescriptionForBundleGridCenteredProps): JSX.Element => (
  <ContainerDescription
    alignItems={alignItems}
    rowGap={rowGap}
    paddings={paddings}
    width={100}
    {...rest}
  >
    <TextBlockDescriptionForBundleGridCenter
      title={title}
      description={description}
      rentedText={rentedText}
      descriptionPreWrap
    />
    {children ? (
      children
    ) : isButtonShown && buttonTitle ? (
      <PrimaryButton onClick={onSeeAllClick} title={buttonTitle} />
    ) : null}
  </ContainerDescription>
)

ContainerDescriptionForBundleGridCentered.displayName =
  'ContainerDescriptionForBundleGridCentered'
